import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { toggleSpinnerAndContainer } from "../shared/pageComponents"; 

document.addEventListener('DOMContentLoaded', () => {
    toggleSpinnerAndContainer('embla-spinner', 'embla-container', 1000);
});

const productCards = document.querySelector('.product-cards');

gsap.registerPlugin(ScrollTrigger);

function productCardActions() {
  // Set all cards to animate with stagger once .product-cards enters
  gsap.fromTo(".product-card",
    { opacity: 0, y: 50 },
    {
      opacity: 1,
      y: 0,
      duration: 0.5,
      stagger: {
        each: 0.15,
        from: "start"
      },
      ease: "power3.out",
      scrollTrigger: {
        trigger: ".product-cards",
        start: "top 110%",
        toggleActions: "play none none none",
        once: true
      }
    }
  );
}

// Ensure trigger refreshes after images/layout settle
window.addEventListener("load", () => {
  if (productCards) productCardActions();
  setTimeout(() => ScrollTrigger.refresh(), 200);
});